import React, { Component } from "react";
import { connect } from "react-redux";

import { CommonModelImpl } from "../../admin/common/CommonModel";
import SideBar from "../../admin/common/sideBar";
import NoData from "../../admin/common/NoData";

import HeaderAdminpanel from "../common/HeaderAdminpanel";
import http from "../../../util/http";
import { axiosInstnace, getAdminData } from "../../../util/util";
import { endPoints } from "../../../config";
import { getServerDataWithTypes } from "../../../action/common_action";
import { ANY_ERROR } from "../../../action/user_action_types";
import moment from "moment";

class requestDeleteDSA extends Component {
  constructor(props) {
    super(props);
    //Set initial state
    this.state = {
      adminData: getAdminData(),
      adminsData: [],
      currentDSA: {},
      currentAdmin: "",
      searchName: "",
      status: "",
      showDeletePopup: false,
      showDeletePopupForSelected: false,
      selectedEmail: "",
      msg: "",
      page: 1,
      skip: 0,
      limit: 10,
      searchfield: "",
      isSelectedAll: false,
      selectedDSA: []
    };
  }

  //make a call to fetch admin
  componentDidMount = async () => {
    this.getSearch();
  };

  //Set data of admin to state
  componentWillReceiveProps = (nextProps) => {
    let { adminsData } = nextProps;
    if (adminsData) {
      this.setState({
        adminsData: adminsData ? adminsData : [],
      });
    }
  };
  
  //Making an http request
  serverCalls = async (url, data) => {
    const response = await http.post(url, data);
    if (response && response.data.statusCode == 200) {
      if(this.state.isSelectedAll){
        return;
      }else if(this.state.selectedDSA.length){
        this.setState({
          selectedDSA: []
        })
      }
      this.componentDidMount();
    } else {
      this.props.showError(
        response ? response.data.message : "Something is wrong"
      );
    }
  };
  // /Delete a admin
  deleteAdmin = () => {
    let { currentAdmin } = this.state;
    let { _id } = currentAdmin;
    let data = { _id };
    this.serverCalls(endPoints.deleteAdmin, data);
    this.setState({
      page: 1,
      currentAdmin: {},
      msg: "",
      showDeletePopup: false,
    });
  };

  deleteAdminForSelected = () => {
    let { currentAdmin } = this.state;
    let data = {_id: JSON.stringify(currentAdmin)};
    this.serverCalls(endPoints.deleteMultipleAdmin, data);
    this.setState({
      page: 1,
      currentAdmin: {},
      msg: "",
      adminsData: []
    });
    this.showHideDeletePopupForSelected();
  }
  //Show hide delete popup
  showHideDeletePopup = (currentAdmin) => {
    let { adminData } = this.state;
    if (currentAdmin && currentAdmin.email == adminData.email) {
      return this.props.showError("You can not delete yourself!");
    }
    this.setState({
      currentAdmin: currentAdmin ? currentAdmin : {},
      msg: currentAdmin ? "Are you sure you want to delete?" : "",
      showDeletePopup: !this.state.showDeletePopup,
    });
  };

  showHideDeletePopupForSelected = (selected = undefined) => {
    if(selected){
      let { adminData, adminsData, isSelectedAll, selectedDSA } = this.state;
      let currentAdmin = undefined;

      if(isSelectedAll){
        currentAdmin = adminsData.map( admin => admin.email).filter( admin => admin != adminData.email);
      }else if(selectedDSA){
        currentAdmin = selectedDSA.filter( admin => admin != adminData.email);
      }
      /* if (currentAdmin && currentAdmin.email == adminData.email) {
        return this.props.showError("You can not delete yourself!");
      } */
      this.setState({
        currentAdmin: currentAdmin.length ? currentAdmin : {},
        msg: currentAdmin ? "Are you sure you want to delete selected records?" : "",
        showDeletePopupForSelected: !this.state.showDeletePopupForSelected,
      });
    }else{
      this.setState({
        currentAdmin: {},
        showDeletePopupForSelected: !this.state.showDeletePopupForSelected,
      });
    }
    
  };

  getSearch = async () => {
    let url = `${endPoints.getalldsausers}`;
    let param = {
      showOnlyDeleted: 'true',
      search: this.state.searchfield
    };
    let admins = await axiosInstnace.get(url, {
      params: param,
    });
    this.setState({
      adminsData: admins.data.data,
    });
  };

  viewDSADetails = async (dsa) => {
    this.setState({
      currentDSA: dsa,
      showviewDSAPopup: true,
    });
  };

  toggleDeleteRequestModal = (tpEmail = undefined) => {
    let { adminData } = this.state;
    if(tpEmail){
      if (tpEmail == adminData.email) {
        return this.props.showError("You can not delete yourself!");
      }else{
        this.setState({
          currentAdmin: tpEmail,
          showTPDeleteRequest: !this.state.showTPDeleteRequest,
        });
      }
    }else{
      this.setState({
        showTPDeleteRequest: !this.state.showTPDeleteRequest,
      });
    }
  };
  
  submitDeleteTPRequest = async () => {
    if(this.state.requestDeleteReason){
      let { currentAdmin, adminData, requestDeleteReason } = this.state;
      if (currentAdmin.email == adminData.email) {
        return this.props.showError("You can not delete yourself!");
      }
      const deleteRequestResult = await axiosInstnace.post(endPoints.deleteTPRequest, {
          email: currentAdmin, deleteReason: requestDeleteReason ,
        }
      );
  
      if(deleteRequestResult.data){
        let adminsData = this.state.adminsData.filter(tradePartner=> tradePartner.email != this.state.currentAdmin);
  
        this.setState({
          adminsData: adminsData,
          showTPDeleteRequest: !this.state.showTPDeleteRequest,
        });
      } 
    }else{
      this.props.showError("Enter reason for trade partner delete request");
    }
  };

  //Admin logout
  logout = () => {
    localStorage.removeItem("adminInfo");
    window.location.href = "/admin/login";
  };

  hideshowuserCampaigns = () => {
    this.setState({
      showUserCampaigns: !this.state.showUserCampaigns,
    });
  };

  selectAllDSA = (e) => {
    this.setState({
      selectedDSA: [],
      isSelectedAll: !this.state.isSelectedAll
    });
  };

  selectDSA = (dsaEmail) => {
    this.setState({
      isSelectedAll: false
    });

    if(this.state.selectedDSA && this.state.selectedDSA.includes(dsaEmail)){
      this.setState({
        selectedDSA: this.state.selectedDSA.filter( dsa => dsa != dsaEmail )
      });
    }else{
      let selectedDSAtoPush = this.state.selectedDSA;
      selectedDSAtoPush.push(dsaEmail);

      this.setState({
        selectedDSA: selectedDSAtoPush
      });
    }
  };

  render() {
    let {
      adminsData,
      showDeletePopup,
      showDeletePopupForSelected,
      msg
    } = this.state;
    return (
      <div>
        {!this.state.showviewDSAPopup && !this.state.showUserCampaigns && (
          <div className="dashboardContainer">
            <HeaderAdminpanel />
            <div className="dashboardContainer-inner">
              <section id="sidebar">
                <SideBar parent="0" child="0" />
              </section>
              <section
                id="dashboard-rightContainer"
                className="dashboard-manageSales"
              >
                <div className="container-head">
                  <div className="dashboard-breadcrumb">
                    Trade Partner Management |
                    <span className="breadcrumb-active advertiser-breadcrumb">
                      Deleted Trade Partners
                    </span>
                  </div>

                  <div
                    className="search_camp"
                  >
                    <input
                      type="text"
                      placeholder="search"
                      ref={this.state.searchfield}
                      onChange={(e) => {
                        this.setState(
                          {
                            searchfield: e.target.value,
                          },
                          () => this.getSearch()
                        );
                      }}
                    />
                    <span>
                      <img src="/assets/images/search.png" />
                    </span>
                  </div>
                </div>
                
                <div
                  className={
                    adminsData.length === 0
                      ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                      : "dashboard-content userListing-dashboard bg-white table-responsive"
                  }
                >
                  { this.state.adminData.role === "admin" ? (
                    <div style={{width: "100%"}}>
                      { (this.state.isSelectedAll || this.state.selectedDSA.length) ? (
                        <button style={{padding: "10px", margin: "10px 5px", background: "#207cc0", color: "white", float: "right"}} onClick={() =>
                            this.showHideDeletePopupForSelected(true)
                          } >Delete Selected</button>
                      ) : (
                        <button style={{padding: "10px", margin: "10px 5px", background: "rgb(214 214 214)", color: "white", float: "right", cursor: "not-allowed"}} disabled="true" >Delete Selected</button>
                      ) }
                      
                    </div>
                  ) : ''}
                  
                  <table className="table table-striped master-table">
                    <thead>
                      <tr>
                        { this.state.adminData.role === "admin" && (
                          <th>
                            <label>
                              <input type="checkbox" checked={this.state.isSelectedAll} onChange={this.selectAllDSA} />
                            </label>
                          </th>
                        )}
                        <th>Name</th>
                        <th>City</th>
                        <th>Mobile</th>
                        <th>Email</th>
                        <th>Last Update</th>
                        <th>Registration date</th>
                        <th>Status</th>
                        <th>Deleted By</th>
                        <th>Reason for Deletion</th>
                      </tr>
                    </thead>
                    <tbody>
                      {adminsData.map((data, index) => {
                        return (
                          <tr key={index}>
                            { this.state.adminData.role === "admin" && (
                              <td>
                                <label>
                                  <input type="checkbox" checked={ (this.state.isSelectedAll || (this.state.selectedDSA && this.state.selectedDSA.includes(data.email)) ) } onClick={ (e) => {
                                    this.selectDSA(data.email);
                                  } } />
                                </label>
                              </td>
                            )}
                            <td>{data.name}</td>
                            <td>{data.city}</td>
                            <td>{data.mobile}</td>
                            <td>{data.email}</td>

                            <td>
                              {data.previousKycStatuses &&
                                data.previousKycStatuses.length > 0 && (
                                  <span>
                                    {moment(
                                      data.previousKycStatuses[
                                        data.previousKycStatuses.length - 1
                                      ].time
                                    ).format("DD/MM/YYYY hh:mm A")}
                                  </span>
                                )}
                              {data.previousKycStatuses &&
                                data.previousKycStatuses.length == 0 && (
                                  <span>NA</span>
                                )}
                            </td>
                            <td>
                              {data.joiningdate && (
                                <span>
                                  {moment(data.joiningdate).format(
                                    "DD/MM/YYYY hh:mm A"
                                  )}
                                </span>
                              )}
                              {!data.joiningdate && <span>NA</span>}
                            </td>
                            <td
                              style={{
                                color:
                                  data.kycstatus &&
                                  data.kycstatus.status === "Verified"
                                    ? "#97b911"
                                    : data.kycstatus &&
                                      data.kycstatus.status === "Rejected"
                                    ? "red"
                                    : data.kycstatus &&
                                      data.kycstatus.status === "Submitted"
                                    ? "blue"
                                    : "orange",
                              }}
                            >
                              {data.kycstatus && data.kycstatus.status
                                ? data.kycstatus.status
                                : "Pending"}
                            </td>
                            <td>{data.deleteRequestBy}</td>
                            <td>{data.deleteRequestReason}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  

                  
                  
                  

                  <div className="paginationTable" />
                  {/* {(skip > 0 || totalRecord > 10) &&
                  <Pagination getAllData={this.getAllData} totalRecords={totalRecord} />
                } */}
                </div>
                {adminsData.length === 0 ? <NoData /> : null}
              </section>
            </div>
          </div>
        )}
        
        
        {showDeletePopup && (
          <CommonModelImpl
            headerMsg={"Trade Partner Delete"}
            msg={msg}
            okButtonShow={true}
            okButtonText={"PROCEED"}
            okAction={this.deleteAdmin}
            cancelButtonShow={true}
            cancelButtonText={"No"}
            cancelAction={this.showHideDeletePopup}
          />
        )}

        {showDeletePopupForSelected && (
          <CommonModelImpl
            headerMsg={"Trade Partners Delete"}
            msg={msg}
            okButtonShow={true}
            okButtonText={"PROCEED"}
            okAction={this.deleteAdminForSelected}
            cancelButtonShow={true}
            cancelButtonText={"No"}
            cancelAction={this.showHideDeletePopupForSelected}
          />
        )}
      </div>

      
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminsData: state.user.get("adminsData"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminsData: (url, type) => dispatch(getServerDataWithTypes(url, type)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(requestDeleteDSA);


// WEBPACK FOOTER //
// ./web/components/admin/dsa_management/requestDeleteDSA.js